import { useQueryClient } from '@tanstack/react-query';
import { useStyledToast } from './general.hooks';
import {
  useArchiveInsight,
  useReadInsight,
  useSaveInsight,
  useShareInsight
} from '@services/query-services/insights.query-service';

/**
 * @see {@link /src/util/hooks/card.hooks.js} - useCardActions variant for insights
 */
export const useInsightActions = (_optimisticUpdateConfig) => {
  const optimisticUpdateConfig = { enabled: true, ..._optimisticUpdateConfig };
  const toast = useStyledToast();
  const queryClient = useQueryClient();
  const { mutate: saveInsight } = useSaveInsight({ optimisticUpdateConfig });
  const { mutate: archiveInsight } = useArchiveInsight({ optimisticUpdateConfig });
  const { mutate: shareInsight } = useShareInsight({ optimisticUpdateConfig });
  const { mutate: readInsight } = useReadInsight({ optimisticUpdateConfig });

  return (action, value, insight, pageIndex, insightIndex) => {
    let mutationVars = { id: insight.id, value, action };
    if (optimisticUpdateConfig.type === 'infinite') {
      mutationVars = { ...mutationVars, pageIndex, recordIndex: insightIndex };
    }
    if (action === 'save')
      saveInsight(mutationVars, {
        onSuccess: () => {
          queryClient.invalidateQueries(['insights'], { refetchType: 'all' });
        }
      });
    else if (action === 'archive')
      archiveInsight(mutationVars, {
        onSuccess: () => {
          const actionText = value ? 'Archived' : 'Unarchived';
          toast({ status: 'success', title: `Insight ${actionText} Successfully` });
          queryClient.invalidateQueries(['insights'], { refetchType: 'all' });
        }
      });
    else if (action === 'read') readInsight(mutationVars);
    else if (action === 'share') {
      shareInsight({
        ...mutationVars,
        optimisticUpdateValue: value ? new Date() : null,
        optimisticUpdateAttribute: 'shared_at'
      });
    }
  };
};
